<template>
    <!-- Taker2maker - покупаем внешний, отдаем внутренний -->
    <!-- Maker2taker - покупаем внутренний, отдаем внешний -->
    <div>
        <div class="d-flex justify-content-between align-items-center" :class="{ 'mb16': !isMobile, 'mb32': isMobile }">
            <div v-if="isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': isMobile }">
                <h4 class="mb-0 fsp20 lh28 neue">{{ this.getTitle() }}</h4>
            </div>
            <div v-if="!isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div class="d-flex" :class="{ 'flex-column-reverse': isMobile, 'gap-3': !isMobile }">
            <div class="bg-white rounded12 fsp14" :class="{ 'p24 max-w-50': !isMobile }">
                <div class="d-flex align-items-center gap-3 justify-content-between" :class="{ 'mb16 pb16 border-b': !isMobile, 'mb16': isMobile }">
                    <div class="fsp20 lh28 neue d-flex align-items-center">
                        <span>{{ this.content.maker_name ? this.content.maker_name : this.content.maker_uid }}</span>
                        <Icon v-if="this.content.maker_verified != '0'" name="verify" class="c20 ml4" />
                    </div>
                    <div v-if="this.content.maker_avg_rate" class="d-flex align-items-center gap-1">
                        <span class="fsp14 lh20 neue color-orange">{{ this.$lib.precRound(this, Number(this.content.maker_avg_rate), 1) }}</span>
                        <Icon name="star-outline" size="c14" class="mrp-4" />
                    </div>
                </div>
                <div class="d-flex flex-column gap-3 mb16 pb16 border-b">
                    <div class="d-flex justify-content-between align-items-center lh20 gap-3">
                        <div class="primary-grey lh20 neue-roman">{{ $t('views.P2P.RequestP2POffer.16') }}</div>
                        <div class="d-flex align-items-center">
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-center">
                                    <span>{{ this.content.code }}</span>
                                    <Icon v-if="this.content.only_for_verified != '0'" name="verify" class="c16 ml4" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center lh20 gap-3">
                        <span class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.15') }}</span>
                        <div>
                            <span class="color-notification-green">{{ this.content.maker_swaps_success }}</span>
                            <span class="primary-grey"> / </span>
                            <span class="color-notification">{{ this.content.maker_swaps_fail }}</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center lh20 gap-3">
                        <div class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.9') }}</div>
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="d-flex align-items-center">
                                <Icon name="clock" :active="false" class="c16 mr4" />
                                {{ this.content.timeout }} {{ $t('views.P2P.RequestP2POffer.1') }}
                            </span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center lh20 gap-3">
                        <div class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.17') }}</div>
                        <div class="d-flex justify-content-between align-items-center">
                            <div v-html="this.getRate()" />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column gap-3">
                    <div class="d-flex align-items-center justify-content-between lh20 gap-3">
                        <span class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.4') }}</span>
                        <Icon name="check-green" class="c20" />
                    </div>
                    <div class="d-flex align-items-center justify-content-between lh20 gap-3">
                        <span class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.5') }}</span>
                        <div class="d-flex align-items-center col-6 text-truncate">
                            <a :href="getOfferURL()" target="_blank" class="color-menu text-decoration-underline text-truncate">{{ getOfferURL() }}</a>
                            <Icon name="copy" class="c16 pointer" @click="this.$lib.copyTextS(getOfferURL(), this.$store)" />
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between lh20 gap-3">
                        <span class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.6') }}</span>
                        <div class="d-flex align-items-center">
                            <span>{{ this.content.maker_uid }}</span>
                            <Icon name="copy" class="c16 pointer ml4" @click="this.$lib.copyTextS(this.content.maker_uid, this.$store)" />
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between lh20 gap-3">
                        <span class="primary-grey neue-roman">{{ $t('views.P2P.RequestP2POffer.10') }}</span>
                        <span>{{ this.formatDate(this.content.dt_create) }}</span>
                    </div>
                    <div v-if="this.content.external_note" class="lh20">
                        <span class="d-inline-block primary-grey neue-roman mb8 ">{{ $t('views.P2P.RequestP2POffer.8') }}</span>
                        <div class="neue-roman">{{ this.content.external_note }}</div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column justify-content-between" :class="{ 'max-w-50': !isMobile }">
                <div class="bg-white rounded12 position-relative" :class="{ 'p24': !isMobile }">   
                    <div class="border-full rounded8 px12 py8 d-flex align-items-center gap-2" @click="this.$refs.payAmountInput.focusInput()">
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="primary-grey neue-roman fsp12 lh16">{{ $t('views.P2P.RequestP2POffer.11') }}</div>
                            <InputSimple 
                                :id='this.content.internal_direction == "Taker2maker" ? "amount" : "amount_to"'
                                ref="payAmountInput"
                                class="border-0 h24 p-0"
                                type='text'
                                :dataValue='this.content.internal_direction == "Taker2maker" ? this.data.amount : this.data.amount_to'
                                :regCheck='{f: (arg) => {
                                    return this.content.internal_direction == "Taker2maker" ? 
                                        this.checkAmount(arg, "amount") : 
                                        this.checkAmount(arg, "amount_to");
                                }}'
                                :require="true" 
                                :invalid="this.content.internal_direction == 'Taker2maker' && this.check_amount"
                                :invalidHint="$t('views.P2P.RequestP2POffer.19')"
                                placeholder="0"
                                @updateParentState="this.setValue" 
                            />
                        </div>
                        <div 
                            @click.stop="setMaxAmount('amount')" 
                            class="pointer color-notification-green mr12"
                        >
                            {{ $t('views.P2P.RequestP2POffer.14') }}
                        </div>
                        <div v-if="this.content.internal_direction == 'Taker2maker'">
                            <img v-if="this.keywords[0]?.image" :src="this.keywords[0].image" class="c32" />
                            <Icon v-else name="default-curr" size="c32" />
                        </div>
                        <div>{{ this.sellAsset }}</div>
                    </div>
                    <div v-if="this.content.internal_direction == 'Taker2maker'" class="d-flex align-items-center mt8" :class="{ 'flex-column': isMobile }">
                        <SelectSimple
                            id='keyt'
                            :hotUpdate="true"
                            :dataValue='this.data.keyt'
                            :defaultValue="$t('views.P2P.RequestP2POffer.18')"
                            :keywords.sync='this.keywords' 
                            @updateParentState="this.setValue"  
                            :isSearch="true"
                            :keyt="true"
                        />
                        <Button
                            @mouseenter="hoverIcon = 'plus'"
                            @mouseleave="hoverIcon = false"
                            class="h56 w56 flex-shrink-0"
                            :class="{ 'mt8 w-100': isMobile, 'ml8': !isMobile }"
                            type='btn-outline-warning' 
                            @click='this.goToNewKeyt()'
                        >
                            <Icon name="plus" class="c20" :active="hoverIcon === 'plus'" />
                        </Button>
                    </div>
                    <div v-if="this.content.internal_direction == 'Taker2maker'" class="primary-grey neue fsp12 lh16 mt8">
                        {{ $t('views.P2P.RequestP2POffer.13') }} 
                        <span>
                            <span>{{ this.$lib.formatNumberWithSeparators(this.content.internal_min.split('.')[0]) }}</span>
                            <span v-if="this.content.internal_min.split('.')[1]" class="fsp10">.{{ this.content.internal_min.split('.')[1] }}</span>
                        </span> - 
                        <span>
                            <span>{{ this.$lib.formatNumberWithSeparators(this.content.internal_max.split('.')[0]) }}</span>
                            <span v-if="this.content.internal_max.split('.')[1]" class="fsp10">.{{ this.content.internal_max.split('.')[1] }}</span>
                        </span>
                        <span class="ml4">{{ content.internal_curr_text }}</span>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="arrows-element">
                            <Icon name="arrow-up-down" :active="false" class="c14" />
                        </div>
                    </div>
                </div>
                <div class="bg-white rounded12":class="{ 'p24': !isMobile }">
                    <div class="border-full rounded8 px12 py8 d-flex align-items-center gap-2" @click="this.$refs.receiveAmountInput.focusInput()">
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="primary-grey neue-roman fsp12 lh16">{{ $t('views.P2P.RequestP2POffer.12') }}</div>
                            <InputSimple 
                                :id='this.content.internal_direction == "Maker2taker" ? "amount" : "amount_to"'
                                ref="receiveAmountInput"
                                class="border-0 h24 p-0"
                                type='text'
                                :dataValue='this.content.internal_direction == "Maker2taker" ? this.data.amount : this.data.amount_to'
                                :regCheck='{f: (arg) => {
                                    return this.content.internal_direction == "Maker2taker" ? 
                                        this.checkAmount(arg, "amount") : 
                                        this.checkAmount(arg, "amount_to");
                                }}'
                                :require="true"
                                :invalid="this.content.internal_direction == 'Maker2taker' && this.check_amount"
                                :invalidHint="$t('views.P2P.RequestP2POffer.19')"
                                placeholder="0"
                                @updateParentState="this.setValue"
                            />
                        </div>
                        <div v-if="this.content.internal_direction == 'Maker2taker'">
                            <img v-if="this.keywords[0]?.image" :src="this.keywords[0].image" class="c32" />
                            <Icon v-else name="default-curr" size="c32" />
                        </div>
                        <div>{{ this.buyAsset }}</div>
                    </div>
                    <div v-if="this.content.internal_direction == 'Maker2taker'" class="d-flex mt8" :class="{ 'flex-column': isMobile }">
                        <SelectSimple
                            id='keyt'
                            :hotUpdate="true"
                            :dataValue='this.data.keyt'
                            :keywords.sync='this.keywords'
                            :defaultValue="$t('views.P2P.RequestP2POffer.18')"
                            @updateParentState="this.setValue"  
                            :isSearch="true"
                            :keyt="true"
                        />
                        <Button
                            @mouseenter="hoverIcon = 'plus'"
                            @mouseleave="hoverIcon = false"
                            class="h56 w56 flex-shrink-0"
                            :class="{ 'w-100 mt8': isMobile, 'ml8': !isMobile }"
                            type='btn-outline-warning' 
                            @click='this.goToNewKeyt()'
                        >
                            <Icon name="plus" class="c20" :active="hoverIcon === 'plus'" />
                        </Button>
                    </div>
                    <div v-if="this.content.internal_direction == 'Maker2taker'" class="primary-grey neue fsp12 lh16 mt8">
                        {{ $t('views.P2P.RequestP2POffer.13') }} 
                        <span>
                            <span>{{ this.$lib.formatNumberWithSeparators(this.content.internal_min.split('.')[0]) }}</span>
                            <span v-if="this.content.internal_min.split('.')[1]" class="fsp10">.{{ this.content.internal_min.split('.')[1] }}</span>
                        </span> - 
                        <span>
                            <span>{{ this.$lib.formatNumberWithSeparators(this.content.internal_max.split('.')[0]) }}</span>
                            <span v-if="this.content.internal_max.split('.')[1]" class="fsp10">.{{ this.content.internal_max.split('.')[1] }}</span>
                        </span>
                        <span class="ml4">{{ content.internal_curr_text }}</span>
                    </div>
                    <div :class="{ 'my16 pb16 border-b': isMobile, 'mt24': !isMobile }">
                        <Button 
                            :name="$t('views.P2P.RequestP2POffer.2')" 
                            class="w-100 h48"
                            type='btn-success' 
                            v-on:click="this.requestP2PSwap"
                            :disabled="this.isNoKeyts || isBtnSendDisable"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button'; 
import Select from '@/components/service/Select';
import SelectSimple from '@/components/service/SelectSimple';
import Input from '@/components/service/Input';
import Switch from '@/components/service/Switch';
import InputSimple from '@/components/service/InputSimple';
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';

export default {
    components: {
        Button,
        Select,
        SelectSimple,
        Input,
        Switch,
        InputSimple,
        SwitchSimple,
        Tooltip,
        Icon
    },
    props: {
        close: [Function],
    }, 
    data () {
        return { 
            content: this.$store.state.modal.content.offer,
            keywords: [],
            data: {
                amount: '',
                amount_to: '',
                keyt: false,
                proffer: this.$store.state.modal.content.offer.code
            },
            isNoKeyts: false,
            prec_rate: 4,
            curr_list: [],
            external_curr_prec: '1',
            internal_curr_prec: '1',
            btnIconClass: 'ext-link-orange',
            check_amount: false,
            hoverIcon: false,
        }
    },
    computed: {
        t () {
            let k = this.$store.getters.get_keyts_keywords;
            if (k.length > 0) {
                this.getKeyts(k);
            }
            return k;
        },
        buyAsset() {
            return this.content.internal_direction == 'Maker2taker' ? this.content.internal_curr_text : this.content.external_type_unit_abbreviation || this.content.external_type_text;
        },
        sellAsset() {
            return this.content.internal_direction == 'Maker2taker' ? this.content.external_type_unit_abbreviation || this.content.external_type_text : this.content.internal_curr_text;
        },
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        isBtnSendDisable() {
            const keyt = this.keywords.find(item => item.code == this.data.keyt);
            const notEnoughBalance = this.content.internal_direction == 'Taker2maker' && this.data.keyt && keyt?.balance < this.data.amount;
            const userNotVerified = this.content.only_for_verified == '1' && this.$store.state.userData.user_info_advanced?.personified !== '1';

            if(userNotVerified || notEnoughBalance) {
                return true
            }
            return this.data.amount == '' || this.data.amount_to == '' || this.data.keyt == false || this.check_amount == true;
        },
    },
    watch: {
        t: {
            handler: function(newData, oldData) {
                // console.log(newData)
                this.getKeyts(newData);
            },
            deep: true,
        }
    },
    methods: {
        getOfferURL() {
            return `${window.location.origin}/p2p/offers?offerCode=${this.content.code}`;
        },
        setMaxAmount(field) {
            this.setValue({id: field, value: this.content.internal_max});
        },
        getTitle() {
            return `${this.$t('views.P2P.RequestP2POffer.2')} ${this.buyAsset} ${this.$t('views.P2P.RequestP2POffer.3')} ${this.sellAsset}`;
        },
        checkAmountValue() {
            return Number(this.data.amount) < Number(this.content.internal_min) || Number(this.data.amount) > Number(this.content.internal_max);
        },
        getCurrsPrec() {
            let ext_curr, int_curr;
            this.axios.post('GetListCurr', {no_loader: true}).then(res => {
                let l = res.data.body;

                if(l.length != 0) {
                    l.forEach(e => {
                        e['value'] = e.full_name;         
                    });
                    this.curr_list = l;

                    if (this.curr_list.length > 0) {
                        if (this.content.external_curr == '0' && this.content.external_type_unit_precision != '0') {
                            this.external_curr_prec = this.content.external_type_unit_precision;
                        } else {
                            ext_curr = this.curr_list.find(curr => curr.code == this.content.external_curr);
                            this.external_curr_prec = ext_curr ? ext_curr.precision : '2';
                        }

                        int_curr = this.curr_list.find(curr => curr.code == this.content.internal_curr);
                        this.internal_curr_prec = int_curr ? int_curr.precision : '2';
                    }
                }

                //console.log('this.external_curr_prec', this.external_curr_prec);
                //console.log('this.internal_curr_prec', this.internal_curr_prec);
            })
        },
        toLongTailFixed(num, prec, lengthTail) {
            let str = String(num);
            // длина обрезаемой части
            const lengthOfCutPart = lengthTail - prec;
            // длина числа, новая
            const lengthCutNumber = str.length - lengthOfCutPart;

            str = str.slice(0, lengthCutNumber + 1);
            return str;
        },
        checkAmount(arg, inputId) {
            let prec;

            if (inputId == 'amount' && this.content.internal_direction == 'Maker2taker') {
                prec = this.internal_curr_prec;
            }

            if (inputId == 'amount_to' && this.content.internal_direction == 'Maker2taker') {
                prec = this.external_curr_prec;
            }

            if (inputId == 'amount' && this.content.internal_direction == 'Taker2maker') {
                prec = this.internal_curr_prec;
            }

            if (inputId == 'amount_to' && this.content.internal_direction == 'Taker2maker') {
                prec = this.external_curr_prec;
            }

            prec = prec > 15 ? 15 : prec;

            //console.log('prec', prec);

            arg = String(arg);
            arg = arg.replace(',', ".");
            let regExp = new RegExp(/[^0-9.]/g);
            let t = arg.replace(regExp, "");
            if(t === '.') {
                t = '';
            }
            if(t.split('.').length > 2) {
                t = t.slice(0, t.length - 1);
            }
            if (t === '') {
                t = '';
            } else if (t[t.length - 1] != '.') {
                let ind = t.indexOf('.');

                const lengthTail = t.length - ind;
                if (ind !== -1) {
                    if (lengthTail > 10 || t.length > 10) {
                        t = this.toLongTailFixed(t, prec, lengthTail);
                        // преобразование в число, Number не можем использовать - Number компонент
                        t = +t;
                    } else {
                        const tail = t.split('.')[1]
                        t = `${t.split('.')[0]}.${tail.slice(0, prec)}`;
                    }
                }
            }

            if (prec == 0) {
                t = t.replace('.', '');
            }
            arg = String(t);

            return arg;
        },
        calculateSumm(arg) {
            if (!Number(arg.value)) {
                this.data[arg.id] = 0;
            }

            const rate = this.$lib.ev(this, `${this.content.rate_external_count} / ${this.content.rate_internal_count}`);
            const rateСoefficient = this.getRateFrom(rate) == 1 ? this.getRateTo(rate) : this.getRateFrom(rate);
            //console.log('internal dir', this.content.internal_direction);
            //console.log('arg id', arg.id);

            if (arg.id == 'amount' && this.getRateFrom(rate) == 1) {
                this.data['amount'] = this.$lib.precRound(this, 
                    Number(arg.value), 
                    Number(this.internal_curr_prec > 15 ? 15 : this.internal_curr_prec)
                );
                this.data['amount_to'] = this.$lib.precRound(this, 
                    Number(arg.value) / Number(rateСoefficient), 
                    Number(this.external_curr_prec > 15 ? 15 : this.external_curr_prec)
                );
            }

            if (arg.id == 'amount' && this.getRateTo(rate) == 1) {
                this.data['amount'] = this.$lib.precRound(this, 
                    Number(arg.value), 
                    Number(this.internal_curr_prec > 15 ? 15 : this.internal_curr_prec)
                );
                this.data['amount_to'] = this.$lib.precRound(this, 
                    Number(arg.value) * Number(rateСoefficient), 
                    Number(this.external_curr_prec > 15 ? 15 : this.external_curr_prec)
                );
            }

            if (arg.id == 'amount_to' && this.getRateFrom(rate) == 1) {
                this.data['amount_to'] = this.$lib.precRound(this, 
                    Number(arg.value), 
                    Number(this.external_curr_prec > 15 ? 15 : this.external_curr_prec)
                );
                this.data['amount'] = this.$lib.precRound(this, 
                    Number(arg.value) * Number(rateСoefficient), 
                    Number(this.internal_curr_prec > 15 ? 15 : this.internal_curr_prec)
                );
            }

            if (arg.id == 'amount_to' && this.getRateTo(rate) == 1) {
                this.data['amount_to'] = this.$lib.precRound(this, 
                    Number(arg.value), 
                    Number(this.external_curr_prec > 15 ? 15 : this.external_curr_prec)
                );
                this.data['amount'] = this.$lib.precRound(this, 
                    Number(arg.value) / Number(rateСoefficient), 
                    Number(this.internal_curr_prec > 15 ? 15 : this.internal_curr_prec)
                );
            }

        },
        setValue(arg) {
            if (arg.id == 'amount' || arg.id == 'amount_to') {
                this.calculateSumm(arg);

                this.check_amount = this.data.amount ? this.checkAmountValue() : false;

                return;
            }

            this.data[arg.id] = arg.value;
        },
        getKeyts(k) {
            this.keywords = k.slice();

            this.keywords = this.keywords.filter(keyt => keyt.curr == this.content.internal_curr_text);

            if (this.keywords.length == 0) {
                this.isNoKeyts = true;
            }

            if (this.keywords.length == 1) {
                this.data.keyt = this.keywords[0].code;
            }

        },
        getRateFrom(rate, revers = false) {
            let rate_from;
            if (Number(rate) >= 1) {
                rate_from = revers ? '1' : String(rate);
            } else {
                rate_from = revers ? this.$lib.ev(this, `1 / ${rate}`) : '1';
            }

            return this.$lib.precRound(this, rate_from, this.prec_rate);
        },
        getRateTo(rate, revers = false) {
            let rate_to;
            if (Number(rate) >= 1) {
                rate_to = revers ? String(rate) : '1';
            } else {
                rate_to = revers ? '1' : this.$lib.ev(this, `1 / ${rate}`);
            }

            return this.$lib.precRound(this, rate_to, this.prec_rate);
        },
        getRate() {
            const sum_from = this.$lib.formatNumberWithSeparators(this.$lib.precRound(this, this.content.internal_direction == 'Maker2taker' ? this.content.rate_internal_count : this.content.rate_external_count, this.prec_rate));
            const sum_to = this.$lib.formatNumberWithSeparators(this.$lib.precRound(this, this.content.internal_direction == 'Maker2taker' ? this.content.rate_external_count : this.content.rate_internal_count, this.prec_rate));
            const text_from = this.buyAsset;
            const text_to = this.sellAsset;

            return `<span>${sum_from.split('.')[0]}<span><span class="${sum_from.split('.')[1] ? 'fsp10 primary-grey' : 'd-none'}">.${sum_from.split('.')[1]}</span> <span class="primary-grey">${text_from}</span> - <span>${sum_to.split('.')[0]}</span><span class="${sum_to.split('.')[1] ? 'fsp10 primary-grey' : 'd-none'}">.${sum_to.split('.')[1]}</span> <span class="primary-grey">${text_to}</span></span>`
        },
        formatDate(date) {
            return date.split(' ')[0].split('-').reverse().join('.') + ' ' + date.split(' ')[1];
        },
        requestP2PSwap() {
            let params = {
                amount: this.data.amount,
                keyt: this.data.keyt,
                proffer: this.data.proffer
            }
            // DELTA: disabled
            // this.axios.post('RequestP2PSwap', {data: params}).then(res => {
            //     if (res.data.body.result == '0') {
            //         this.close();
            //         this.$router.push({name: 'p2p_single_swap', query: {swap: res.data.body.advanced.swap}});
            //     }
            // });
        },
        goToNewKeyt() {
            let url = '/keyts/list?create=1';
            
            if(this.content.internal_direction == 'Taker2maker') {
                url = url + '&curr=' + this.content.internal_curr;
            }
            
            window.open(url, '_blank');
        },
        getExternalName() {
            if (this.content.external_curr_text) {
                return this.content.external_curr_text;
            } else if (this.content.external_type_unit_abbreviation) {
                return this.content.external_type_unit_abbreviation;
            } else {
                return ''
            }
        }
    },

    mounted() {
        this.getCurrsPrec();
    }
}
</script>

<style lang="scss" scoped>
.max-w-50 {
    width: calc(50% - 8px);
}

.h24 {
    height: 24px;
}

.h56 {
    height: 56px;
}

.w56 {
    width: 56px;
}

.color-orange {
    color: $dark-orange;
}

.arrows-element {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 70%);
    border-radius: 50%;
    background-color: white;
    padding: 5px;
    border: 4px solid $bg-light-grey;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        position: relative;
        transform: none;
        bottom: auto;
        left: auto;
        justify-content: center;
        margin: 8px 0px;
    }
}
</style>